import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/map';

import {
  MiningShovelInspectionOverview,
  CompartMeasurementPoint,
  MeasurementPointReadings,
  MeasurementPointObservation,
  SaveReportParams,
  RecommendationParams,
  InspectionPhoto,
  IntroductionParams,
  AdditionalRecordDetails,
  SummaryParams,
  SaveRecommendationPhotoParams,
  OverallComments,
  ReportPrefillContentViewModel,
  ChangePhotoCommentAPINames,
  ToggleHideAndShowResult
} from './report-builder-models';
import { catchError } from 'rxjs/operators';
import { Tuple } from '../../../../../app/entities';

@Injectable()
export class ReportBuilderService {
  constructor(private _http: HttpClient) {

  }
  private handleError(error: Response) {
    console.error(error);
    return Observable.throw(error.json().error || 'Server error');
  }

  public GetMSInspectionDetails(MSInspectionID: number): Observable<MiningShovelInspectionOverview> {
    let options = {
      params: new HttpParams().set('MSInspectionID', MSInspectionID.toString())
    };
    return this._http.get<MiningShovelInspectionOverview>("Api/MSInspection/GetMSInspectionDetails", options).pipe(catchError(this.handleError));
  }
  
  public releaseRopeReport(MSInspectionID: number): Observable<Tuple> {
    const options = {
      params: new HttpParams().set('MSInspectionID', MSInspectionID.toString())
    };
    return this._http.get<Tuple>('Api/MSInspection/ReleaseRopeReport', options).pipe(catchError(this.handleError));
  }

  public GetMeasurementPointReadings(MSInspectionID: number, measurePointID: number): Observable<MeasurementPointReadings> {
    let options = {
      params: new HttpParams().set('MSInspectionID', MSInspectionID.toString()).set('measurePointID', measurePointID.toString())
    };
    return this._http.get<MeasurementPointReadings>("Api/MSInspection/GetMeasurementPointReadings", options).pipe(catchError(this.handleError));
  }

  public GetMeasurementPointObservations(MSInspectionID: number, measurePointID: number): Observable<MeasurementPointObservation[]> {
    let options = {
      params: new HttpParams().set('MSInspectionID', MSInspectionID.toString()).set('measurePointID', measurePointID.toString())
    };
    return this._http.get<MeasurementPointObservation[]>("Api/MSInspection/GetMeasurementPointObservations", options).pipe(catchError(this.handleError));
  }

  public GetCompartMeasurementPoints(compartTypeID: number, EqId: number, report_id): Observable<CompartMeasurementPoint[]> {
    let options = {
      params: new HttpParams().set('compartTypeID', compartTypeID.toString()).set('EqId', EqId.toString()).set('report_id', EqId.toString())
    };
    return this._http.get<CompartMeasurementPoint[]>("Api/MSInspection/GetCompartMeasurementPoints", options).pipe(catchError(this.handleError));
  }

  public GetMeasurementPointImages(MSInspectionID: number, measurePointID: number): Observable<InspectionPhoto[]> {
    let options = {
      params: new HttpParams().set('MSInspectionID', MSInspectionID.toString()).set('measurePointID', measurePointID.toString())
    };
    return this._http.get<InspectionPhoto[]>("Api/MSInspection/GetMeasurementPointImages", options).pipe(catchError(this.handleError));
  }

  public SaveReport(params: SaveReportParams): Observable<any> {
    return this._http.post("Api/MSInspection/SaveReport", params).pipe(catchError(this.handleError));
  }

  public SaveRecommendationPhoto(params: SaveRecommendationPhotoParams): Observable<any> {
    return this._http.post("Api/MSInspection/SaveRecommendationPhoto", params).pipe(catchError(this.handleError));
  }

  public SaveRecommendation(params: RecommendationParams): Observable<any> {
    return this._http.post("Api/MSInspection/SaveRecommendation", params).pipe(catchError(this.handleError));
  }

  public GetRecommendations(reportId: number): Observable<RecommendationParams[]> {
    let options = {
      params: new HttpParams().set('reportId', reportId.toString())
    };
    return this._http.get<RecommendationParams[]>("Api/MSInspection/GetRecommendations", options).pipe(catchError(this.handleError));
  }

  public GetUoM(): Observable<any> {
    return this._http.get("Api/WSRE/GetUserUOM").pipe(catchError(this.handleError));
  }

  public GetEquipmentPhotos(MSInspectionID: number): Observable<InspectionPhoto[]> {
    let options = {
      params: new HttpParams().set('MSInspectionID', MSInspectionID.toString())
    };
    return this._http.get<InspectionPhoto[]>("Api/MSInspection/GetEquipmentPhotos", options).pipe(catchError(this.handleError));
  }

  public GetRecommendationPhotos(recommendationID: number): Observable<InspectionPhoto[]> {
    let options = {
      params: new HttpParams().set('recommendationID', recommendationID.toString())
    };
    return this._http.get<InspectionPhoto[]>("Api/MSInspection/GetRecommendationPhotos", options).pipe(catchError(this.handleError));
  }

  public GetAllInspectionPhotos(MSInspectionID: number): Observable<InspectionPhoto[]> {
    let options = {
      params: new HttpParams().set('MSInspectionID', MSInspectionID.toString())
    };
    return this._http.get<InspectionPhoto[]>("Api/MSInspection/GetAllInspectionPhotos", options).pipe(catchError(this.handleError));
  }

  public GetMandatoryPhotos(MSInspectionID: number, compartTypeID: number): Observable<InspectionPhoto[]> {
    let options = {
      params: new HttpParams().set('MSInspectionID', MSInspectionID.toString()).set('compartTypeID', compartTypeID.toString())
    };
    return this._http.get<InspectionPhoto[]>("Api/MSInspection/GetMandatoryPhotos", options).pipe(catchError(this.handleError));
  }

  public GetAdditionalPhotos(MSInspectionID: number, compartTypeID: number): Observable<InspectionPhoto[]> {
    let options = {
      params: new HttpParams().set('MSInspectionID', MSInspectionID.toString()).set('compartTypeID', compartTypeID.toString())
    };
    return this._http.get<InspectionPhoto[]>("Api/MSInspection/GetAdditionalPhotos", options).pipe(catchError(this.handleError));
  }

  public GetAdditionalRecords(MSInspectionID: number, compartTypeID: number): Observable<AdditionalRecordDetails[]> {
    let options = {
      params: new HttpParams().set('MSInspectionID', MSInspectionID.toString()).set('compartTypeID', compartTypeID.toString())
    };
    return this._http.get<AdditionalRecordDetails[]>("Api/MSInspection/GetAdditionalRecords", options).pipe(catchError(this.handleError));
  }

  public GetReportIntroduction(reportId: number): Observable<IntroductionParams> {
    let options = {
      params: new HttpParams().set('reportId', reportId.toString())
    };
    return this._http.get<IntroductionParams>("Api/MSInspection/GetReportIntroduction", options).pipe(catchError(this.handleError));
  }


  public GetPrefilledReportContent(equipmentId: number): Observable<ReportPrefillContentViewModel> {
    let options = {
      params: new HttpParams().set('equipmentId', equipmentId.toString())
    };
    return this._http.get<ReportPrefillContentViewModel>("Api/MSInspection/GetPrefilledReportContent", options).pipe(catchError(this.handleError));
  }

  public SaveReportIntroduction(params: IntroductionParams): Observable<any> {
    return this._http.post("Api/MSInspection/SaveReportIntroduction", params).pipe(catchError(this.handleError));
  }

  public GetReportSummary(reportId: number): Observable<SummaryParams> {
    let options = {
      params: new HttpParams().set('reportId', reportId.toString())
    };
    return this._http.get<SummaryParams>("Api/MSInspection/GetReportSummary", options).pipe(catchError(this.handleError));
  }

  public SaveReportSummary(params: SummaryParams): Observable<any> {
    return this._http.post("Api/MSInspection/SaveReportSummary", params).pipe(catchError(this.handleError));
  }

  public GetOverallComments(MSInspectionID: number, compartTypeID: number): Observable<OverallComments> {
    let options = {
      params: new HttpParams().set('MSInspectionID', MSInspectionID.toString()).set('compartTypeID', compartTypeID.toString())
    };
    return this._http.get<OverallComments>("Api/MSInspection/GetOverallComments", options).pipe(catchError(this.handleError));
  }

  public SaveOverallComments(params: OverallComments): Observable<any> {
    return this._http.post("Api/MSInspection/SaveOverallComments", params).pipe(catchError(this.handleError));
  }

  public GetGeneralNotes(MSInspectionID: number): Observable<any> {
    let options = {
      params: new HttpParams().set('MSInspectionID', MSInspectionID.toString())
    };
    return this._http.get("Api/MSInspection/GetGeneralNotes", options).pipe(catchError(this.handleError));
  }

  public GetCoverPhoto(photoId: number): Observable<InspectionPhoto> {
    let options = {
      params: new HttpParams().set('photoId', photoId.toString())
    };
    return this._http.get<InspectionPhoto>("Api/MSInspection/GetCoverPhoto", options).pipe(catchError(this.handleError));
  }

  public GetRSReportClient(): Observable<any> {
      let options = {
          params: new HttpParams()
      };
      return this._http.get("Api/MSInspection/GetRSReportClient", options).pipe(catchError(this.handleError));
  }

  public ChangeImageComment(photoId: number, changedComment: string, changeOption: ChangePhotoCommentAPINames) {
    let options = {
      params: new HttpParams().set('photoId', photoId.toString()).set('changedComment', changedComment)
    };
    let url = ChangePhotoCommentAPINames[changeOption];
    return this._http.get("Api/MSInspection/" + url, options).pipe(catchError(this.handleError));
  }

  //////////////////////////////
  // Delete items from report //
  //////////////////////////////
  public DeleteRecommendationPhoto(recommendationPhotoID: number): Observable<any> {
    let options = {
      params: new HttpParams().set('recommendationPhotoID', recommendationPhotoID.toString())
    };
    return this._http.delete("Api/MSInspection/DeleteRecommendationPhoto", options).pipe(catchError(this.handleError));
  }

  public DeleteRecommendation(recommendationID: number): Observable<any> {
    let options = {
      params: new HttpParams().set('recommendationID', recommendationID.toString())
    };
    return this._http.delete("Api/MSInspection/DeleteRecommendation", options).pipe(catchError(this.handleError));
  }

  ////////////////////////////////////
  // Show or hide items from report //
  ////////////////////////////////////
  public ToggleInspectionMandatoryPhoto(photoId: number, reportId: number): Observable<ToggleHideAndShowResult> {
    let options = {
      params: new HttpParams().set('photoId', photoId.toString()).set('reportId', reportId.toString())
    };
    return this._http.get<ToggleHideAndShowResult>("Api/MSInspection/ToggleInspectionMandatoryPhoto", options).pipe(catchError(this.handleError));
  }

  public ToggleComparttypeMandatoryPhoto(photoId: number, reportId: number): Observable<ToggleHideAndShowResult> {
    let options = {
      params: new HttpParams().set('photoId', photoId.toString()).set('reportId', reportId.toString())
    };
    return this._http.get<ToggleHideAndShowResult>("Api/MSInspection/ToggleComparttypeMandatoryPhoto", options).pipe(catchError(this.handleError));
  }

  public ToggleComparttypeAdditionalPhoto(photoId: number, reportId: number): Observable<ToggleHideAndShowResult> {
    let options = {
      params: new HttpParams().set('photoId', photoId.toString()).set('reportId', reportId.toString())
    };
    return this._http.get<ToggleHideAndShowResult>("Api/MSInspection/ToggleComparttypeAdditionalPhoto", options).pipe(catchError(this.handleError));
  }

  public ToggleMeasurementPointPhoto(photoId: number, reportId: number, isHidden : boolean): Observable<ToggleHideAndShowResult> {
    let options = {
      params: new HttpParams().set('photoId', photoId.toString()).set('reportId', reportId.toString()).set('status', isHidden.toString())
    };
    return this._http.get<ToggleHideAndShowResult>("Api/MSInspection/ToggleMeasurementPointPhoto", options).pipe(catchError(this.handleError));
  }

  public ToggleMeasurementPointNotes(measurePointID: number, reportId: number, isHidden : boolean, side:string, desc:string): Observable<ToggleHideAndShowResult> {
    let options = {
      params: new HttpParams().set('measurePointID', measurePointID.toString()).set('reportId', reportId.toString()).set('status', isHidden.toString()).set('side', side).set('desc', desc)
    };
    return this._http.get<ToggleHideAndShowResult>("Api/MSInspection/ToggleMeasurementPointNotes", options).pipe(catchError(this.handleError));
  }

  

  public ToggleMeasurementPointRecord(measurePointID: number, reportId: number): Observable<ToggleHideAndShowResult> {
    let options = {
      params: new HttpParams().set('measurePointID', measurePointID.toString()).set('reportId', reportId.toString())
    };
    return this._http.get<ToggleHideAndShowResult>("Api/MSInspection/ToggleMeasurementPointRecord", options).pipe(catchError(this.handleError));
  }

  public ToggleMeasurementPoint(measurePointID: number, reportId: number): Observable<ToggleHideAndShowResult> {
    let options = {
      params: new HttpParams().set('measurePointID', measurePointID.toString()).set('reportId', reportId.toString())
    };
    return this._http.get<ToggleHideAndShowResult>("Api/MSInspection/ToggleMeasurementPoint", options).pipe(catchError(this.handleError));
  }

  public ToggleComparttypeAdditionalRecord(compartTypeID: number, reportId: number): Observable<ToggleHideAndShowResult> {
    let options = {
      params: new HttpParams().set('compartTypeID', compartTypeID.toString()).set('reportId', reportId.toString())
    };
    return this._http.get<ToggleHideAndShowResult>("Api/MSInspection/ToggleComparttypeAdditionalRecord", options).pipe(catchError(this.handleError));
  }

  public GetStatusOfAdditionalRecord(compartTypeID: number, MSInspectionID: number): Observable<any> {
    let options = {
      params: new HttpParams().set('compartTypeID', compartTypeID.toString()).set('MSInspectionID', MSInspectionID.toString())
    };
    return this._http.get("Api/MSInspection/GetStatusOfAdditionalRecord", options).pipe(catchError(this.handleError));
  }

  public ToggleRecommendationImageResize(isLarge: boolean, imageCategoryId: number): Observable<any> {
    let options = {
      params: new HttpParams().set('isLarge', isLarge.toString()).set('imageCategoryId', imageCategoryId.toString())
    };
    return this._http.get("Api/MSInspection/ToggleRecommendationImageResize", options).pipe(catchError(this.handleError));
  }

  public ToggleReportImageResize(isLarge: boolean, photoId: number, photoType: number, reportId: number): Observable<any> {
    let options = {
      params: new HttpParams().set('isLarge', isLarge.toString()).set('photoId', photoId.toString()).set('photoType', photoType.toString()).set('reportId', reportId.toString())
    };
    return this._http.get("Api/MSInspection/ToggleReportImageResize", options).pipe(catchError(this.handleError));
  }

  public GetAxialGapCalculations(MSInspectionID: number): Observable<AdditionalRecordDetails[]> {
    let options = {
      params: new HttpParams().set('MSInspectionID', MSInspectionID.toString())
    };
    return this._http.get<AdditionalRecordDetails[]>("Api/MSInspection/GetAxialGapCalculations", options).pipe(catchError(this.handleError));
  }

  public SendReport(MSInspectionID: number, sendToAddress: string, customerName: string, reportUoM: string, style:number): Observable<any> {
    let options = {
      params: new HttpParams().set('MSInspectionID', MSInspectionID.toString()).set('sendToAddress', sendToAddress).set('sendToUserName', customerName).set('reportUoM', reportUoM)
      .set('style', style.toString())
    };
    return this._http.get("Api/MSInspection/SendReport", options).pipe(catchError(this.handleError));
  }
}
